import { SpeakerHigh, SpeakerLow, SpeakerX } from 'phosphor-react'
import { useVolume } from '../../contexts/VolumeContext'
import styles from './VolumeControl.module.css'

export default function VolumeControl() {
  const { volume, showVolumeIndicator } = useVolume()

  const getSpeakerIcon = () => {
    const iconProps = { size: 16, weight: 'fill' as const, color: '#000' }
    if (volume === 0) return <SpeakerX {...iconProps} />
    if (volume > 0 && volume <= 66) return <SpeakerLow {...iconProps} />
    return <SpeakerHigh {...iconProps} />
  }

  const handleClick = () => {
    showVolumeIndicator()
  }

  return (
    <button 
      className={styles.iconButton}
      onClick={handleClick}
      aria-label="Volume"
    >
      {getSpeakerIcon()}
    </button>
  )
}